import React, { useCallback, useEffect, useState } from "react";

// Jds
import { Button, Container, Divider, Notifications, Text } from "@jds/core";

// Local
import MuiPopover from "../../MuiPopover";
import NotificationGroup from "./NotificationGroup";
import NotificationItem from "./NotificationItem";
import useApiHttp from "../../../../hooks/use-http";
import EmptyState from "../../../NoData/EmptyState";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { shareModalTrigger } from "../../../../store/state-slices/apiTrigger";

export default function NotificationPopover(props) {
  const { data } = props;
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { sendRequest, isLoading } = useApiHttp();

  useEffect(() => {
    if (notificationOpen) {
      sendRequest(
        {
          url: `notification/WEB`,
        },
        null,
        (data) => {
          setNotificationData(data.data);
        }
      );
    }
  }, [notificationOpen]);

  const handleGuestNavigation = useCallback((type, eventId) => {
    if (type === "GuestDownloadAccess") {
      // dispatch(shareModalTrigger());
      navigate(`/home/events/share/${eventId}`);
    }

    if (type === "GuestRegistration") {
      navigate(`/home/events/guests/${eventId}`, {
        state: {
          // requestAccess: type === "GuestDownloadAccess" ? true : false,
          registerGuest: type === "GuestRegistration" ? true : false,
        },
      });
    }
  }, []);
  return (
    <MuiPopover
      {...props}
      sx={{
        padding: "20px 24px 32px",
        width: "432px",
        // maxHeight: "80vh",
        overflow: "auto",
      }}
    >
      <NotificationBody
        notificationData={notificationData}
        eventId={eventId}
        handleGuestNavigation={handleGuestNavigation}
        setNotificationOpen={setNotificationOpen}
      />
    </MuiPopover>
  );
}

const NotificationBody = (props) => {
  const {
    close,
    notificationData,
    eventId,
    handleGuestNavigation,
    setNotificationOpen,
  } = props;
  const { sendRequest: clearNotification, isLoading: isClearNotification } =
    useApiHttp();

  const clearNotificationClickHandler = () => {
    clearNotification(
      {
        url: `notification/clear`,
        method: "POST",
      },
      null,
      (data) => {
        Notifications.toast.success({ id: "noti-clear", tilte: data.message });
        props.close();
      },
      (data) => {
        Notifications.toast.error({ id: "noti-clear", tilte: data.message });
      }
    );
  };
  useEffect(() => {
    setNotificationOpen((pre) => !pre);
    return () => {
      setNotificationOpen((pre) => !pre);
    };
  }, []);
  return (
    <Container direction="column" gap={16} fullWidth>
      <Container fullWidth direction="column" gap={0}>
        <Container
          verticalAlign="center"
          horizontalAlign="space-between"
          fullWidth
        >
          <Text text="Notification" appearance="body-m-bold" />
          {notificationData?.length && (
            <Box
            // sx={{
            //   "& .text-atom": {
            //     color: "var(--custom-color-primary-60)",
            //   },
            //   ".j-JDSButton-container:hover": {
            //     backgroundColor: "var(--custom-color-primary-20)",
            //   },
            // }}
            >
              <Button
                kind="tertiary"
                label="Clear All"
                onClick={() => {
                  clearNotificationClickHandler();
                }}
              />
            </Box>
          )}
        </Container>
        <Divider pad="xx-small" padPosition="vertical" />
      </Container>
      <Container
        fullWidth
        direction="column"
        gap={32}
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        {/* <NotificationGroup />
    <NotificationGroup title="This Week" />
    <NotificationGroup title="Past Month" /> */}
        <Container fullWidth direction="column" horizontalAlign="center">
          {notificationData?.length > 0 ? (
            notificationData.map((item, i) => (
              <NotificationGroup
                key={i}
                data={item}
                onClick={() => {
                  handleGuestNavigation(item.type, item.event);
                  props.close();
                }}
              // title="This Week"
              />
            ))
          ) : (
            <EmptyState title="No Notifications found" action={false} />
          )}
        </Container>
      </Container>
    </Container>
  );
};
